/**
 * Handles fraction to decimal conversion calculations
 */
export class FractionConverter {
  /**
   * Convert a fraction string to decimal
   * @param {string} fraction - Fraction in format "numerator/denominator" (e.g., "3/4")
   * @returns {number|null} Decimal value rounded to 4 places, or null if invalid
   */
  toDecimal(fraction) {
    if (!fraction || !fraction.includes('/')) {
      return null
    }

    const parts = fraction.split('/')
    
    if (parts.length !== 2) {
      return null
    }

    const numerator = parseFloat(parts[0])
    const denominator = parseFloat(parts[1])

    if (isNaN(numerator) || isNaN(denominator) || denominator === 0) {
      return null
    }

    return this.round(numerator / denominator)
  }

  /**
   * Divide numerator by denominator
   * @param {number} numerator - The numerator
   * @param {number} denominator - The denominator
   * @returns {number|null} Decimal value rounded to 4 places, or null if invalid
   */
  divide(numerator, denominator) {
    if (isNaN(numerator) || isNaN(denominator) || denominator === 0) {
      return null
    }

    return this.round(numerator / denominator)
  }

  /**
   * Round a number to 4 decimal places
   * @private
   */
  round(value) {
    return Math.round((value + 0.00001) * 10000) / 10000
  }
}
